"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyAdditionalBrokerLicense = void 0;
function makeEmptyAdditionalBrokerLicense() {
    return {
        brokerLicense: '',
        participationPercentage: 0,
    };
}
exports.makeEmptyAdditionalBrokerLicense = makeEmptyAdditionalBrokerLicense;
//# sourceMappingURL=AdditionalBrokerLicense.js.map